import React, { FC, useCallback } from 'react';
import { Card } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { FORM_FIELDS } from '../../../../../constants';
import { useBoolean } from '@sravni/react-utils';
import styles from './styles.module.scss';
import { UseFormReturn } from 'react-hook-form';
import { MonthlySalaryField } from '../../../../../helpers/form.new/fields/work';

interface SalaryFieldProps {
    form: UseFormReturn;
    showFocusTooltip?: boolean;
}

export const SalaryField: FC<SalaryFieldProps> = (props) => {
    const { form, showFocusTooltip = true, ...other } = props;

    const {
        control,
        formState: { errors, dirtyFields: _ },
    } = form;

    const [hasTooltipSalary, setHasTooltipSalary] = useBoolean(false);

    const onSalaryBlur = useCallback(() => {
        setHasTooltipSalary.off();
    }, [setHasTooltipSalary]);

    const onFocus = useCallback(() => {
        setHasTooltipSalary.on();
    }, [setHasTooltipSalary]);

    return (
        <div className={styles['salary']}>
            {hasTooltipSalary && showFocusTooltip && (
                <Card className={styles['salary__tip']}>
                    <Text className={styles['salary__tip-text']}>
                        Укажите тот доход после вычета налогов, который вы можете подтвердить
                    </Text>
                </Card>
            )}
            <MonthlySalaryField
                control={control}
                error={errors[FORM_FIELDS.MONTHLY_SALARY]?.message}
                onFocus={onFocus}
                onBlur={onSalaryBlur}
                {...other}
            />
        </div>
    );
};
